type StartupMetricKey =
  | 'auth_bootstrap_ms'
  | 'workspace_ready_ms'
  | 'first_shell_paint_ms'
  | 'chat_ready_ms'
  | 'splash_hide_ms';

type StartupMetricsState = Partial<Record<StartupMetricKey, number>>;

const startupOriginMs =
  typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now();

const startupMetrics: StartupMetricsState = {};

function getNowMs() {
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now();
  }

  return Date.now();
}

function shouldLogStartupMetrics() {
  return typeof __DEV__ !== 'undefined' && __DEV__;
}

export function getStartupMetricValue(metric: StartupMetricKey) {
  return startupMetrics[metric] ?? null;
}

export function getStartupMetricsSnapshot() {
  return { ...startupMetrics };
}

export function markStartupMetric(
  metric: StartupMetricKey,
  value = getNowMs() - startupOriginMs,
) {
  if (startupMetrics[metric] != null) {
    return startupMetrics[metric]!;
  }

  const normalizedValue = Math.max(0, Math.round(value));
  startupMetrics[metric] = normalizedValue;

  if (shouldLogStartupMetrics()) {
    console.log(`[startup] ${metric}=${normalizedValue}ms`, getStartupMetricsSnapshot());
  }

  return normalizedValue;
}
